import { Link } from 'react-scroll';
import { FormattedMessage } from 'react-intl';

const MenuItem = (props) => {
  const { titleKey, linkRef, onClick, linkTo, source, defaultTitle } = props;
  return (
    <li className="nav-item">
      <Link
        target={linkRef}
        className="nav-link "
        smooth
        duration={500}
        style={{ cursor: 'pointer' }}
        activeClass="active"
        spy
        to={linkTo}
        onClick={onClick}
        source={source}>
        <FormattedMessage id={titleKey} defaultMessage={defaultTitle} />
      </Link>
    </li>
  );
};

export default MenuItem;
